import { observer } from "mobx-react-lite"

import type { VenammSellStore } from "@/domains/venamm"
import { BodyXs } from "@/domains/design/components/body-xs"
import { cn } from "@/domains/library/cn"
import { venammStepMap } from "@/domains/lock-page/components/card/venamm-card/composables/venamm-steps/venamm-step-map"
import { ZapCompleted } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-completed"
import { ZapFailed } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-failed"
import { ZapOnChainAction } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-on-chain-action"
import { ZapSpinner } from "@/domains/minimal-pools-zap/components/zap/composables/zap-icons/zap-spinner"

interface VenammProgressIndicatorProps {
  store: VenammSellStore
  className?: string
}

export const VenammProgressIndicator = observer(({ store, className }: VenammProgressIndicatorProps) => {
  const steps = venammStepMap[store.state]

  // Only show progress indicator when the selling process has started
  // (not during quote phase: idle, quoting, quote-ready, quote-failed)
  if (steps.length === 0) {
    return null
  }

  return (
    <ul className={cn("steps w-full self-center", className)}>
      {steps.map((step) => (
        <li key={step.key} className={step.className} data-content={step.dataContent}>
          {step.customIcon === "spinner" ? <ZapSpinner /> : null}
          {step.customIcon === "completed" ? <ZapCompleted /> : null}
          {step.customIcon === "failed" ? <ZapFailed /> : null}
          {step.customIcon === "onchain-action" ? <ZapOnChainAction /> : null}
          <BodyXs> {step.title}</BodyXs>
        </li>
      ))}
    </ul>
  )
})
